import * as types from '@/constants/mutationTypes'

const state = {
  usersListProjects: []
}
const getters = {
  usersListProjects: state => state.usersListProjects
}
const actions = {
  setUsersListProjects ({commit}, data) {
    commit(types.SET_USERS_LIST_PROJECTS, {data})
  }
}
const mutations = {
  [types.SET_USERS_LIST_PROJECTS] (state, {data}) {
    state.usersListProjects = data
  }}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Users/modules/store.js